export interface TopicItem {
  id: string;
  title: string;
  description: string;
  cover: string;
  movieIds: string[];
}

export const topics: TopicItem[] = [
  {
    id: 'topic-scifi',
    title: '硬核科幻星海探险',
    description: '穿越星辰大海，感受未来科技与未知文明的碰撞，带你领略最震撼的科幻视觉盛宴。',
    cover: 'https://readdy.ai/api/search-image?query=collection%20of%20sci-fi%20space%20movie%20posters%20theme%2C%20stars%20and%20spaceships%20in%20deep%20navy%20blue%20with%20warm%20orange%20nebula%20light%2C%20cinematic%20curated%20collection%20style&width=800&height=500&seq=topic-scifi&orientation=landscape',
    movieIds: ['mv-001', 'mv-004', 'tv-004'],
  },
  {
    id: 'topic-festival',
    title: '国庆档必看佳片',
    description: '献礼国庆，精选年度热门院线大片与口碑剧集，陪你度过一个充实的假期。',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20national%20day%20holiday%20film%20festival%20theme%2C%20celebratory%20warm%20orange%20lantern%20light%20with%20deep%20blue%20night%20sky%20backdrop%2C%20festive%20cinematic%20collection%20style&width=800&height=500&seq=topic-festival&orientation=landscape',
    movieIds: ['tv-001', 'tv-006', 'mv-002'],
  },
  {
    id: 'topic-idol',
    title: '人气影星专场',
    description: '汇聚当红演员代表作品，一站式追星指南，看遍你喜爱明星的高光时刻。',
    cover: 'https://readdy.ai/api/search-image?query=celebrity%20spotlight%20film%20collection%20theme%2C%20glamorous%20red%20carpet%20style%20with%20warm%20orange%20stage%20light%20and%20deep%20blue%20background%2C%20cinematic%20curated%20collection%20style&width=800&height=500&seq=topic-idol&orientation=landscape',
    movieIds: ['tv-003', 'tv-005', 'mv-003'],
  },
  {
    id: 'topic-variety',
    title: '欢乐综艺一网打尽',
    description: '美食、音乐、户外、喜剧，热门综艺精选合集，轻松解压每一天。',
    cover: 'https://readdy.ai/api/search-image?query=variety%20show%20collection%20theme%2C%20colorful%20stage%20lights%20with%20warm%20orange%20and%20deep%20blue%20tones%2C%20energetic%20entertainment%20cinematic%20collection%20style&width=800&height=500&seq=topic-variety&orientation=landscape',
    movieIds: ['va-001', 'va-002', 'va-004'],
  },
];